<div class="md-page md-padded ly-col">
  <badge-list view="card"></badge-list>
</div>
